// File: src/components/forms/SmartSelect/SmartSelect.tsx

import React, { useState } from "react";
import { Select } from "../Select/Select";
import { PickerModal } from "../PickerModal/PickerModal";
import { useMediaQuery } from "../../../hooks";
import { BottomSheetModal } from "../../overlays/BottomSheetModal";
export interface Option {
  label: string;
  value: string;
}

interface SmartSelectProps {
  label?: string;
  placeholder?: string;
  value: string;
  options: Option[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
}

export const SmartSelect: React.FC<SmartSelectProps> = ({
  label,
  value,
  options,
  onChange,
  placeholder,
  disabled = false,
}) => { 
    const isMobile = useMediaQuery("tablet"); // Use "mobile" or "tablet" as your breakpoint    
  const [modalOpen, setModalOpen] = useState(false);

  const selectedLabel = options.find((o) => o.value === value)?.label || placeholder || "Select";

  const handleMobileSelect = (val: string) => {
    const fakeEvent = {
      target: { value: val },
    } as React.ChangeEvent<HTMLSelectElement>;

    onChange(fakeEvent);
    setModalOpen(false);
  };

  return (
    <>
      {isMobile ? (
        <>
        <div
        onClick={() => !disabled && setModalOpen(true)}
        style={{
            padding: "12px 16px",
            border: "1.5px solid #ccc",
            borderRadius: "8px",
            background: "#fff",
            color: "#333",
            fontSize: "16px",
            lineHeight: "24px",
            cursor: disabled ? "not-allowed" : "pointer",
        }}
        >
        {selectedLabel}
        </div>
          <PickerModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            value={value}
            options={options}
            onSelect={handleMobileSelect}
          />
        </>
      ) : (
        <Select
          label={label}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          options={options}
          disabled={disabled}
        />
      )}
    </>
  );
};